module.exports = __webpack_public_path__ + "static/img/摄像头遮挡检测.0a2d5c0a.png";